export default function cleanPrefixAndSuffixes(
  catalogId: string | number | undefined | null,
): string {
  if (catalogId == null) return ''

  // Convertir a string si es un número u otro tipo
  const catalogIdStr = typeof catalogId === 'string' ? catalogId : String(catalogId)

  if (!catalogIdStr) return ''

  const cleaned = catalogIdStr.startsWith('PE ') ? catalogIdStr.substring(3) : catalogIdStr

  // GO no es un sufijo de grupo especial - es parte del código de unidad Gola
  // Se maneja por separado con idCambioGolaBlanco
  return cleaned.replace(/ LA$| RU$| R2$| Li$| Ru$| GO$|LI$/, '')
}
